import { isNullOrUndefined } from 'util';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { delay } from 'q';
import * as d3 from 'd3';
import { ActivatedRoute, Router } from '@angular/router';
import { Options } from '@angular-slider/ngx-slider';
import { HeatindexDataService } from '../../side-bar/heat-watch/heatindex/heatindex-data.service';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-play-bar-ngx',
  templateUrl: './play-bar-ngx.component.html',
  styleUrls: ['./play-bar-ngx.component.scss']
})
export class PlayBarNgxComponent implements OnInit {

  styleObjforBottomBar: {};
  playpause: boolean;
  state = 'stop';
  playWidth: any = 3;
  startIndex: any = 0;
  bottomBarMenuSelectedIndex = 0;
  oldPlayButton: any;
  playBetweenIndex: any = 0;
  forecastLengthSubscription: any;
  playButtonSubscription: any;
  positionSubscription: any;
  forecastLength: any;
  currentIndex: any = 0;
  urlparams: any;
  routeSections: string[] = [];
  playPos: any = 0;
  isChange: boolean = false;
  currentpos: any = -1;
  format: any;
  selectedValue = 0;
  constructor(private route: ActivatedRoute, private router: Router, private heatIndexService: HeatindexDataService, private utils: UtilsService) { }

  @Input() playButtonDisable: boolean;
  @Input() labelStrings: any;
  @Input() component:any
  // @Input() playPosition: number;
  @Output() groupSelected = new EventEmitter<any>();

  value: number = 0;
  options: Options = {
    showTicksValues: false,
    hideLimitLabels: true,
    showSelectionBar: true,
    hidePointerLabels: true,
    stepsArray: [],
  };
  ngOnInit() {

    this.playButtonSubscription = this.utils.getPlayButton().subscribe(playPosition => {
      // console.log("playPosition",playPosition)
      if (!isNullOrUndefined(playPosition) && !isNullOrUndefined(playPosition)) {
        this.playPos = playPosition;
        this.value = playPosition
        // if(this.value!=0)
        // {
        //   this.isChange=true;
        // }

        console.log(playPosition, this.labelStrings)
        setTimeout(() => this.changeStartIndex(playPosition), 10);
      }
      //   this.urlparams = this.getCurrentUrlParams();
      //   this.changebutton();
      //   if (this.playButtonDisable == true) {
      //     // this.oldPlayButton = this.playButtonDisable;
      //     this.styleObjforBottomBar = { width: 0 };
      //     this.state = 'stop';
      //     this.playWidth = 3;
      //     this.startIndex = 0;
      //     this.currentIndex = 0;
      //     this.playBetweenIndex = 0;
      //     this.bottomBarMenuSelectedIndex = 0;
      //     this.changebutton();
      //   }
      //   if (this.labelStrings.length > 0) {
      //     const i = this.bottomBarMenuSelectedIndex;
      //     const width = ((i) * (100 / (this.labelStrings.length - 1)));
      //     this.styleObjforBottomBar = { width: width.toString() + '%' };
      //   }
      // })
      // this.positionSubscription=this.utils.getDefaultPlayPosition().subscribe(value=>{
      //   this.isChange=value;
      //   console.log(value)
      //   this.selectedValue=this.isChange?this.playPos:-1;
      // })
      // this.labelStrings.forEach((value,index)=>{
      //   let obj:any={'value':Number,'legend':String}
      //   obj['value']=index;
      //   obj['legend']=value.label.label;
      //   this.options.stepsArray.push(obj);
    })
    // if(!this.isChange)
    // {
    //    this.value=this.labelStrings.length-1;
    //    console.log(this.value)
    // }
    // console.log(this.labelStrings,this.options.stepsArray);
  }
  onClick(event) {
    // console.log("change startindex from click",event)
    this.changeStartIndex(event);
  }
  ngOnDestroy() {
    if (!isNullOrUndefined(this.forecastLengthSubscription)) {
      this.forecastLengthSubscription.unsubscribe();
    }
    if (!isNullOrUndefined(this.playButtonSubscription)) {
      this.playButtonSubscription.unsubscribe();
    }
    if (!isNullOrUndefined(this.positionSubscription)) {
      this.positionSubscription.unsubscribe();
    }
    localStorage.removeItem('playBarIndex')
    // this.utils.setDefaultPlayPosition(false);
  }

  ngOnChanges(change: SimpleChanges) {
    // if(change.labelStrings){
    //   if (this.labelStrings[this.playPos]) {
    //     console.log("gw groupSelected emitted hell : ",)
    //     this.groupSelected.emit(this.labelStrings[this.playPos]['groupName']);
    //   }
    // }
    this.options.stepsArray = [];
    // console.log(change.labelStrings,change.value)
    if (change.labelStrings) {
      // console.log("stesparay",this.options.stepsArray,change.labelStrings.currentValue,this.value)
      change.labelStrings.currentValue.forEach((value, index) => {
        // console.log(change.stepsArray.currentValue)
        let obj: any = { 'value': Number, 'legend': String }
        obj['value'] = index;
        obj['legend'] = value.label.label;
        // console.log(obj)
        this.options.stepsArray.push(obj);
      })
      // this.manualRefresh.emit();
      // console.log("ischange",this.isChange)
      this.format = this.labelStrings && this.labelStrings[0] && this.labelStrings[0].label && this.labelStrings[0].label.label ? this.getLabelFormat(this.labelStrings[0].label.label) : '- - - -';
      let selectedIndex = localStorage.getItem('playBarIndex')
      let index: any;
      // let index: any = this.component == 'heatwave' ? this.heatIndexService.setBlockNumber() : 0;
      if (!isNullOrUndefined(selectedIndex)) {
        index = Number(selectedIndex)
      } else {
        index = this.component == 'heatwave' ? this.heatIndexService.setBlockNumber() : 0;
      }
      this.state = 'stop';
      this.playWidth = 0;
      this.startIndex = index;
      this.currentIndex = index;
      this.playBetweenIndex = index;
      this.bottomBarMenuSelectedIndex = index;
      this.value = index;
      this.selectedValue = index;
      this.currentpos = index
      const width = ((index + 1) / this.labelStrings.length * 100);
      this.styleObjforBottomBar = { width: width.toString() + '%' };
      this.groupSelected.emit(this.labelStrings[index]['groupName']);
      this.changebutton();
    }

  }

  getValue() {
    if (this.isChange) {
      return this.value;
    }
    else
      return -1;
  }

  setValue(event) {
    // console.log(event)
    this.selectedValue=event;
    if (event == 0) {
      this.groupSelected.emit(this.labelStrings[event]['groupName']);
      this.value = event;
    }
    else
      this.value = event;
    // this.changeStartIndex(value);
  }

  getLabelFormat(labelString) {
    let dates, format;
    if (labelString.includes('/')) {
      dates = labelString.split('/');
      if (dates.length == 3)
        format = '- -/- -/- - - -';
      else if (dates.length == 2)
        format = '- -/- - - -';
    }
    else if (labelString.includes(':')) {
      dates = labelString.split(':');
      if (dates.length == 2)
        format = '- -:- -';
      else if (dates.length == 3)
        format = '- -:- -:- -'
    }
    else {
      format = '- - - -';
    }
    return format;
  }

  async animate() {
    this.changebutton();
    this.playpause = !this.playpause;
    /*This if written for the condition when width is 100 and user clicks play button*/
    if (this.state == 'play' || this.state == 'resume') {
      this.state = 'pause';
      this.changebutton();
      return;
    }

    if (this.state == 'stop') {
      const width = 0;
      this.playWidth = 12 / (this.labelStrings.length - 1);
      this.styleObjforBottomBar = { width: width.toString() };
      // this.groupSelected.emit(this.labelStrings[0]['groupName']);
      this.bottomBarMenuSelectedIndex = 0;
      this.state = 'play';
      this.changebutton();
    } else if (this.state == 'pause') {
      this.state = 'play';
      this.changebutton();
    }
    for (let index = this.startIndex; index <= this.labelStrings.length; index++) {
      this.currentIndex = index;
      this.value = index;
      if ((this.state === 'play' || this.state === 'resume')) {

        // let width = this.playWidth;
        if (index >= this.labelStrings.length) {
          this.startIndex = 0;
          this.currentIndex = 0;
          index = -1;
          this.playWidth = 0;
          this.playBetweenIndex = 0;
          const width = 0;
          this.styleObjforBottomBar = { width: width.toString() + '%' };
          await delay(1000);
          continue;
        }
        // console.log("value",this.value,"index",index,this.labelStrings[index]['groupName'])
        this.groupSelected.emit(this.labelStrings[index]['groupName']);
        this.isChange = true;
        this.selectedValue = index;
        this.bottomBarMenuSelectedIndex = index;
        let i = this.playBetweenIndex;
        localStorage.setItem("playBarIndex",index)
        while (i <= 30) {
          if (this.state === 'play' || this.state === 'resume') {
            const width = ((index) * (100 / (this.labelStrings.length - 1))) + (i * ((100 / (this.labelStrings.length - 1)) / 30)) + (2.5 - ((this.labelStrings.length - 5) / 12));
            const num = 6;
            this.styleObjforBottomBar = { width: width.toString() + '%', transition: num.toString() + 's' + 'ease' };
            // console.log("play",this.labelStrings.length)
            await delay(10);
          } else {
            // console.log("not play")
            this.startIndex = index;
            this.currentIndex = index;
            this.playBetweenIndex = i;
            return;
          }
          i++;
          if (index != this.currentIndex) {
            i = -10;
            index = this.currentIndex;
          }
        }
        this.playBetweenIndex = 0;
        if (index === this.labelStrings.length) {
          this.startIndex = 0;
          this.currentIndex = 0;
          index = -1;
          this.playWidth = 0;
          this.playBetweenIndex = 0;
          const width = 0;
          this.styleObjforBottomBar = { width: width.toString() + '%' };
          await delay(1000);
          continue;
          // this.changebutton();
        }
        await delay(1000);
      } else {
        if (index < this.labelStrings.length) {
          this.startIndex = index;
          this.currentIndex = index;
          this.state = 'pause';
        } else {
          this.startIndex = 1;
          this.currentIndex = 1;
          this.state = 'pause';
        }
        break;
      }
    }
  }

  changeStartIndex(i) {
    this.currentpos = i;
    this.value = i
    // if (i == this.currentIndex) {
    //   return;
    // }
    this.selectedValue = i;
    this.startIndex = i;
    this.currentIndex = i;
    this.bottomBarMenuSelectedIndex = i;
    this.playBetweenIndex = 0;
    // const width = ((i) * (100 / (this.labelStrings.length - 1)));
    // this.styleObjforBottomBar = { width: width.toString() + '%' };
    const width = ((i + 1) / this.labelStrings.length * 100);
    this.styleObjforBottomBar = { width: width.toString() + '%' };
    if (this.labelStrings[i]) {
      this.groupSelected.emit(this.labelStrings[i]['groupName']);
      if (this.component == 'fog') {
        this.utils.enableFogSectorLayer.next(this.labelStrings[i]['type'])
      }
      this.isChange = true;
    }
    localStorage.setItem("playBarIndex", i)
  }

  changebutton() {
    if (this.state == 'play' || this.state == 'resume') {
      d3.select('#button_play i').attr('class', 'fa fa-pause');
    } else {
      d3.select('#button_play i').attr('class', 'fa fa-play');
    }

  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return '';
    } else {
      return this.labelStrings[i]['label']['label'];
    }
  }

  formatDateLabel(label: string): string {
  if (!label) {
    return '';
  }

  const parts = label.trim().split(' ');

      const months = [
      'January', 'February', 'March', 'April',
      'May', 'June', 'July', 'August',
      'September', 'October', 'November', 'December'
    ];

  if (parts.length === 2) {
    const day = parts[0].padStart(2, '0');
    const monthName = parts[1];

    const monthIndex = months.findIndex(
      month => month.toLowerCase() === monthName.toLowerCase()
    );

    if (monthIndex !== -1) {
      const month = (monthIndex + 1).toString().padStart(2, '0');
      const year = new Date().getFullYear();
      return `${day}/${month}/${year}`;
    }
  }
    if (parts.length === 3) {
    const day = parts[0].padStart(2, '0');
    const monthName = parts[1];
    const year = parts[2];

    const monthIndex = months.findIndex(
      month => month.toLowerCase() === monthName.toLowerCase()
    );

    if (monthIndex !== -1) {
      const month = (monthIndex + 1).toString().padStart(2, '0');
      return `${day}/${month}/${year}`;
    }
  }

  return label;
}

  getToolTipValue(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return '';
    } else {
      return this.labelStrings[i]['label']['toolTip'];
    }
  }

  getCurrentUrlParams() {
    const obj = this.route.snapshot.params;
    this.routeSections = this.router.url.split('/');
    if (obj == null || obj == undefined) { return obj; }
    // if (this.routeSections[2] === 'extremeweather' && this.routeSections[3] === 'rainfall' &&
    //   this.routeSections[4] === '24') {
    //   if (Object.keys(this.labelStrings).length === 5) {
    //     const i = Object.keys(this.labelStrings).length - 1;
    //     this.startIndex = i;
    //     this.currentIndex = i;
    //     this.bottomBarMenuSelectedIndex = i;
    //     this.playBetweenIndex = 0;
    //     this.groupSelected.emit(this.labelStrings[i]['groupName']);
    //   }
    // }
    const objectConfig = {};
    for (const key in obj) {
      objectConfig[key] = obj[key];
    }
    return objectConfig;
  }

  showtooltipval() {
    if (this.urlparams['time']) {
      return true;
    }
    if ((this.urlparams['component'] == 'groundwater' && this.urlparams['dashboard'] == 'waterSupply') || this.urlparams['component'] == 'inflowForecast' || this.urlparams['component'] == 'rainfall' || this.urlparams['component'] == 'projectdashboard') {
      return true;
    }
    if ((this.router.url).includes('rainfallnowcast')) {
      return true;
    }
    return false;
  }

  onPrev(index) {
    // console.log("pev value",index)
    this.changeStartIndex(index - 1);
  }

  onNext(index) {
    // console.log("next value",index)
    this.changeStartIndex(index + 1);
  }

}
